module.exports = __webpack_public_path__ + "static/img/img5.3035bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img5.png
// module id = A8++
// module chunks = 1